// Libs
import { useLocation } from "react-router-dom";

export default function Breadcrumbs() {
  const location = useLocation();
  const pathnames: string[] = location.pathname.split("/").filter((x) => x);
  let breadcrumbPath = "";
  function insertSpaceBeforeFirstCapital(str: string): string {
    // Find first uppercase letter and insert space before it
    return str.replace(/([a-z])([A-Z])/, "$1 $2");
  }
  return (
    <>
      <div className="breadcrumbs text-xl font-normal">
        {pathnames.map((name, index) => {
          breadcrumbPath += `${name}`;
          const isLast = index === pathnames.length - 1;
          const displayName = insertSpaceBeforeFirstCapital(name);
          return isLast ? (
            <span key={breadcrumbPath}>
              {" "}
              {pathnames.length !== 1 && ">"}{" "}
              <span className="capitalize text-title">{displayName}</span>
            </span>
          ) : (
            <span key={breadcrumbPath} className="capitalize text-title">
              {displayName}
            </span>
          );
        })}
      </div>
    </>
  );
}
